import { createRouter, createWebHashHistory } from 'vue-router';
import {
  I18N, Storage, GTrack, showFleetHomePageTab,
} from 'core';
import pinia, { useTrackStore } from 'store';
import trackMap from './trackMap';

declare const document: any;

const modules = import.meta.glob('../views/**/index.vue');
const asyncImport = (path: string) => modules[`../views/${path}/index.vue`];

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    // 首页
    { path: '/', redirect: '/home' },
    {
      name: 'home',
      path: '/home',
      component: asyncImport('home'),
      meta: { title: I18N.translate('Fleet_Resdesign_Page_Name_OKXD', '开始'), keepAlive: true },
    },
    {
      name: 'performance',
      path: '/home/performance/:type',
      component: asyncImport('home/performance'),
      meta: { title: I18N.translate('Fleet_Resdesign_Page_Name_OKXD', '开始') },
    },
    {
      name: 'datePicker',
      path: '/home/datePicker',
      component: asyncImport('home/datePicker'),
      meta: { title: I18N.translate('Fleet_Mgt_Select_date_INmY', '选择日期') },
    },
    {
      name: 'sendReport',
      path: '/home/sendReport/:type',
      component: asyncImport('home/sendReport'),
      meta: { title: I18N.translate('Fleet_Mgt_Send_a_orZR', '发送报表') },
    },
    {
      name: 'easyStart',
      path: '/home/easyStart',
      component: asyncImport('home/easyStart'),
      meta: { title: I18N.translate('Fleet_start__rZdn', '新手指引') },
    },
    {
      name: 'taxDetail',
      path: '/home/taxDetail',
      component: asyncImport('home/taxDetail'),
      meta: { title: I18N.translate('Fleet_issue_mmrE_nuXS', '税明细') },
    },
    {
      name: 'summaryDetail',
      path: '/home/summaryDetail',
      component: asyncImport('home/summaryDetail'),
      meta: { title: I18N.translate('Fleet_Resdesign_Income_summary_PZsP', '收入概要') },
    },
    {
      name: 'incomeDetail',
      path: '/home/incomeDetail',
      component: asyncImport('home/incomeDetail'),
      meta: { title: I18N.translate('Fleet_Resdesign_Income_flow_fcPZ', '收入明细') },
    },
    // 司机
    {
      name: 'driver',
      path: '/driver',
      component: asyncImport('driver'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机'), keepAlive: true },
    },
    {
      name: 'driverDetail',
      path: '/driver/detail',
      component: asyncImport('driver/detail'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    {
      name: 'driverBindCars',
      path: '/driver/detail/bindCars',
      component: asyncImport('driver/detail/bindCars'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    {
      name: 'driverAddLedgerRules',
      path: '/driver/detail/addLedgerRules',
      component: asyncImport('driver/detail/addLedgerRules'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    {
      name: 'driverEditLedgerRule',
      path: '/driver/detail/editLedgerRule',
      component: asyncImport('driver/detail/editLedgerRule'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    // 司机-新资金流
    {
      name: 'driverNewBindCar',
      path: '/driver/detail/newBindCar',
      component: asyncImport('driver/detail/newBindCar'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    {
      name: 'driverNewRentExpenses',
      path: '/driver/detail/newRentExpenses',
      component: asyncImport('driver/detail/newRentExpenses'),
      meta: { title: I18N.translate('Fleet_copy_Driver_XTmX', '司机') },
    },
    // 添加司机
    {
      name: 'phoneNumber',
      path: '/driver/addDriver/phoneNumber',
      component: asyncImport('driver/addDriver/phoneNumber'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'bindCars',
      path: '/driver/addDriver/bindCars',
      component: asyncImport('driver/addDriver/bindCars'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'inviteSuccess',
      path: '/driver/addDriver/inviteSuccess',
      component: asyncImport('driver/addDriver/inviteSuccess'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'ledgerRules',
      path: '/driver/addDriver/ledgerRules',
      component: asyncImport('driver/addDriver/ledgerRules'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'workRules',
      path: '/driver/addDriver/workRules',
      component: asyncImport('driver/addDriver/workRules'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'driverJoinFleet',
      path: '/driver/driverJoinFleet',
      component: asyncImport('driver/driverJoinFleet'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow__sJZs', '加入车队邀请') },
    },
    // 添加司机-新资金流
    {
      name: 'newBindCar',
      path: '/driver/addDriver/newBindCar',
      component: asyncImport('driver/addDriver/newBindCar'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    {
      name: 'newRentExpenses',
      path: '/driver/addDriver/newRentExpenses',
      component: asyncImport('driver/addDriver/newRentExpenses'),
      meta: { title: I18N.translate('Fleet_Drivers_Add_a_rMLY', '添加司机') },
    },
    // 车辆
    {
      name: 'vehicle',
      path: '/vehicle',
      component: asyncImport('vehicle'),
      meta: { title: I18N.translate('Fleet_Mgt_Vehicles_GLnp', '车辆'), keepAlive: true },
    },
    {
      name: 'vehicleDetail',
      path: '/vehicle/detail',
      component: asyncImport('vehicle/detail'),
      meta: { title: I18N.translate('Fleet_Mgt_Vehicle_Details_ihSv', '车辆详情') },
    },
    {
      name: 'addedSuccess',
      path: '/vehicle/addedSuccess',
      component: asyncImport('vehicle/addedSuccess'),
      meta: { title: I18N.translate('Fleet_Mgt_Vehicles_GLnp', '车辆') },
    },
    // 个人中心
    {
      name: 'mine',
      path: '/mine',
      component: asyncImport('mine'),
      meta: { title: I18N.translate('Fleet_copy_My_pzKZ', '我的') },
    },
    {
      name: 'feedback',
      path: '/mine/feedback',
      component: asyncImport('mine/feedback'),
      meta: { title: I18N.translate('Fleet_copy_My_pzKZ', '我的') },
    },
    {
      name: 'setting',
      path: '/mine/setting',
      component: asyncImport('mine/setting'),
      meta: { title: I18N.translate('Fleet_Phase3_Set_ozBm', '设置') },
    },
    {
      name: 'easyStartSwitch',
      path: '/mine/easyStartSwitch',
      component: asyncImport('mine/setting/easyStartSwitch'),
      meta: { title: I18N.translate('Fleet_start__rZdn', '新手指引') },
    },
    {
      name: 'setFundMode',
      path: '/mine/setFundMode',
      component: asyncImport('mine/setting/setFundMode'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow_owVN_GnVJ', '费用收取方式') },
    },
    {
      name: 'about',
      path: '/mine/about',
      component: asyncImport('mine/about'),
      meta: { title: I18N.translate('Fleet_copy_My_pzKZ', '我的') },
    },
    // 头像部分
    {
      name: 'profile',
      path: '/mine/profile',
      component: asyncImport('mine/profile'),
      meta: { title: I18N.translate('Fleet_copy_My_pzKZ', '我的') },
    },
    {
      name: 'uptCity',
      path: '/mine/profile/city',
      component: asyncImport('mine/profile/city'),
      meta: { title: I18N.translate('upt-city---index_city_title', '注册城市') },
    },
    // 头像上传流程
    {
      name: 'profileHeadPic',
      path: '/headpic',
      component: asyncImport('mine/profile/headpic'),
      meta: { title: I18N.translate('Fleet_check_HWak_qoaq', '头像上传') },
    },
    {
      name: 'uploadHeadPic',
      path: '/mine/profile/uploadImg',
      component: asyncImport('mine/profile/uploadImg'),
      meta: { title: I18N.translate('Fleet_check_HWak_qoaq', '头像上传') },
    },
    {
      name: 'resPage',
      path: '/mine/profile/resPage',
      component: asyncImport('mine/profile/resPage'),
      meta: { title: I18N.translate('Fleet_check_HWak_qoaq', '头像上传') },
    },
    // 钱包页
    {
      name: 'wallet',
      path: '/wallet',
      component: asyncImport('wallet'),
      meta: { title: I18N.translate('my_wallet', '我的钱包') },
    },
    {
      name: 'balance',
      path: '/wallet/balance',
      component: asyncImport('wallet/balance'),
      meta: {
        title: I18N.translate(
          'magellan.martell.translate.order_compensate.driver_channel.1',
          '余额',
        ),
      },
    },
    {
      name: 'historyBalance',
      path: '/wallet/historyBalance',
      component: asyncImport('wallet/historyBalance'),
      meta: {
        title: I18N.translate(
          'magellan.martell.translate.order_compensate.driver_channel.1',
          '余额',
        ),
      },
    },
    // 新版首页
    {
      name: 'homeNew',
      path: '/homeNew',
      component: asyncImport('homeNew'),
      meta: { title: I18N.translate('', '首页'), keepAlive: true },
    },
    {
      name: 'myIncome',
      path: '/homeNew/myIncome',
      component: asyncImport('homeNew/myIncome'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow__UJcK', '我的收入') },
    },
    {
      name: 'driverExpenses',
      path: '/homeNew/driverExpenses',
      component: asyncImport('homeNew/driverExpenses'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow__CFxF', '司机账单详情') },
    },
    {
      name: 'billList',
      path: '/homeNew/billList',
      component: asyncImport('homeNew/billList'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow__pMHK', '账单列表') },
    },
    {
      name: 'billDetail',
      path: '/homeNew/billDetail',
      component: asyncImport('homeNew/billDetail'),
      meta: { title: I18N.translate('Fleet_NewPaymentFlow__ZxdF', '账单已收明细') },
    },
  ],
});

const trackStore = useTrackStore(pinia);

router.beforeEach((to: any) => {
  showFleetHomePageTab(to.name);

  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = Storage.getCountryConfig().html_default_title;
  }

  // 页面埋点上报
  trackStore.clearTrack();
  const trackList = trackMap?.[to.name] || [];
  const pageShow = () => {
    (trackList || []).forEach((trackId) => {
      trackStore.addTrack({ id: trackId });
    });
  };
  pageShow();
  // 页面上报埋点方法更新
  GTrack.pv({
    id: to.name as string,
  });
});

export default router;
